import React, { useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { DatePicker, Form, Input } from 'antd'
import { FormInstance } from 'antd/es/form'
import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import FormalityStepButton from '../FormalityStepButton'

interface IProps {
  form: FormInstance
  onFinish: any
  loading?: boolean
}
const CapitalDepositConfirm = (props: IProps) => {
  const { t } = useTranslation('legalFormalities')
  const { form, onFinish, loading = false } = props
  const { legalFormality } = useContext(CurrentLegalFormalityContext)
  const [formValid, setFormValid] = useState<boolean>(false)

  const validateFormFields = async () => {
    form
      .validateFields()
      .then(() => setFormValid(true))
      .catch(() => setFormValid(false))
  }

  const handleConfirm = () => {
    const values = { ...form.getFieldsValue() }
    onFinish(values)
  }

  const popupDescription = () => {
    const steps = legalFormality.steps
    const capitalDeposit = steps.indexOf('capital_deposit_uploaded') !== -1
    const description: any = t(t('show.form.submit.confirm.next.description'))

    return capitalDeposit ? (
      <>
        <h6>{t('show.form.submit.confirm.capitalDeposit.description')}</h6>
        <Form.Item
          name={['metadatum', 'capitalDepositDate']}
          label={t('show.form.metadatum.capitalDepositDate.label')}
          rules={[
            {
              required: true,
              message: t(
                'show.form.metadatum.capitalDepositDate.errors.required'
              ),
            },
          ]}
        >
          <DatePicker
            onChange={validateFormFields}
            popupStyle={{ zIndex: 1060 }}
            format={'DD/MM/YYYY'}
          />
        </Form.Item>
        <Form.Item
          name={['metadatum', 'capitalDepositCity']}
          label={t('show.form.metadatum.capitalDepositCity.label')}
          rules={[
            {
              required: true,
              message: t(
                'show.form.metadatum.capitalDepositCity.errors.required'
              ),
            },
          ]}
        >
          <Input onChange={validateFormFields} />
        </Form.Item>
      </>
    ) : (
      description
    )
  }

  return (
    <>
      <FormalityStepButton
        title={t('show.form.submit.confirm.next.title')}
        description={popupDescription()}
        buttonDisabled={loading}
        buttonLabel={t('show.form.submit.confirm.next.label')}
        onConfirm={() => handleConfirm()}
        okConfirmDisabled={!formValid}
      />
    </>
  )
}

export default CapitalDepositConfirm
